<form (ngSubmit)="onSubmit()">
  <fieldset>
    <legend>
      <slot name="consumptionIntervalHeading"></slot>
      <p>
       <slot name="consumptionIntervalBody"></slot>
      </p>
    </legend>
    <ui-input
      variant="radio-enhanced"
      required
      name="consumptionCode"
      [(ngModel)]="consumptionCode">
      <ui-input-option [value]="consumptionCode1">
        <slot name="consumptionInterval1Label"></slot>
        <slot img name="consumptionInterval1Icon"></slot>
      </ui-input-option>
      <ui-input-option [value]="consumptionCode2">
        <slot name="consumptionInterval2Label"></slot>
        <slot img name="consumptionInterval2Icon"></slot>
      </ui-input-option>
      <ui-input-option [value]="consumptionCode3">
        <slot name="consumptionInterval3Label"></slot>
        <slot img name="consumptionInterval3Icon"></slot>
      </ui-input-option>
      <ui-input-option [value]="consumptionCode4">
        <slot name="consumptionInterval4Label"></slot>
        <slot img name="consumptionInterval4Icon"></slot>
      </ui-input-option>
    </ui-input>

  </fieldset>
  <ng-container *ngIf="hideHeatingChoices === 'false'">
    <fieldset>
      <legend>
        <slot name="heatingSystemHeading"></slot>
        <p>
          <slot name="heatingSystemBody"></slot>
        </p>
      </legend>
      <ui-input
        variant="radio-inline"
        name="heatingSystem"
        required
        [readonly]="heatingSystemDisabled"
        [(ngModel)]="heatingSystem">
        <ui-input-option value="true" [selected]="heatingSystem === true">
          <slot name="heatingSystemYesLabel"></slot>
        </ui-input-option>
        <ui-input-option value="false" [selected]="heatingSystem === false">
          <slot name="heatingSystemNoLabel"></slot>
        </ui-input-option>
      </ui-input>
    </fieldset>
  </ng-container>
  <fieldset>
    <button ui-button type="submit" [disabled]="!consumptionCode || !estimatedKWhConsumption">
      <slot name="submitFormButtonText"></slot>
    </button>
  </fieldset>

</form>